<template>
  <div class="upload-list-widget">
    <div class="list-widget">
      <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="is_loading" :is-full-page="false"
        :can-cancel="false" background-color="#f9f9f9" class="loader"></loading>
      <Uploader class="upload-widget" @onFileSelected="(file) => {
        uploadCVImage(file);
      }
        " :max_size="5" caption="Upload your image [max-size: 5MB] [png,jpeg]" remove_caption="" />

      <div class="image-item" v-for="(item, index) in images_list" :key="index">
        <div class="template-header">
          <widgetDropdown v-model="item.menu" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown btn-menu">
              <img class="icon" style="height: 20px" src="@/assets/icon/menu-dot-white.svg" />
            </button>
            <div slot="dropdown" class="cv-dropdown-widget right">
              <app-dialog title="Delete Template" ask="Are you sure you want to permanently delete image?"
                yesText="Delete" noText="Cancel" @onComfirm="deleteImage(item, 'image')">
                <a class="dropdown-item" href="#">Delete </a>
              </app-dialog>
            </div>
          </widgetDropdown>
        </div>
        <img @click="addImage(SITE_API_URL + '/super-manager/cvs/image/download?name=' + item.name)" class="preview"
          :src="$fullUrl('images/profiles/' + item.name)" />
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from "@/main";
import { SITE_API } from "@/Store/variable.js";
export default {
  name: "editor-upload-images",
  components: {},
  props: {
    account_type: {
      type: String,
      default: "school",
    },
  },
  data() {
    return {
      SITE_API_URL: SITE_API,
      images_list: [],
      is_loading: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
    vm.getImagesData();
  },
  methods: {
    addImage(url) {
      let vm = this;
      vm.$emit("setImage", url);
    },
    getImagesData() {
      let vm = this;
      vm.is_loading = true;
      vm.$store
        .dispatch("CVS_ALL_IMAGES", {
          filter: "image",
          type: vm.account_type,
        })
        .then((response) => {
          vm.is_loading = false;
          vm.images_list = response.data;
        })
        .catch((error) => {
          vm.is_loading = false;
          console.error({ error });
        });
    },
    deleteImage(item, type) {
      let vm = this;
      vm.$store
        .dispatch("CVS_IMAGE_DELETE", { id: item.id, type: vm.account_type })
        .then((response) => {
          if (type == "background") {
            vm.getBackgroundData();
          } else if (type == "image") {
            vm.getImagesData();
          }
          vm.$notify({
            group: "status",
            title: "Messsage",
            text: "Image Deleted successfully",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    uploadCVImage(file) {
      let vm = this;
      let formData = new FormData();
      formData.append("image", file, file.name);
      formData.append("type", vm.account_type);
      vm.$store
        .dispatch("CVS_UPLOAD_IMAGES", formData)
        .then((response) => {
          vm.getImagesData();
          eventBus.$emit("removeFile");
          vm.$notify({
            group: "status",
            title: "Messsage",
            text: "Image uploaded",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.upload-list-widget {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .list-widget {
    display: grid;
    grid-template-columns: 47% 47%;
    grid-gap: 10px;
    align-items: flex-start;
    position: relative;

    .upload-widget {
      height: 200px;
      padding: 2px;
    }

    .image-item {
      height: max-content;
      cursor: pointer;
      position: relative;
      border-radius: 10px;
      display: flex;

      .template-header {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        display: flex;
        justify-content: flex-end;
        padding: 5px 10px;
        background: black;
        background: linear-gradient(181deg,
            rgba(105, 105, 105, 0.716) 59%,
            rgba(139, 139, 139, 0) 100%);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }

      img.preview {
        object-fit: contain;
        width: 100%;
        height: 200px;
        border-radius: 10px;
        align-self: center;
        background: rgb(185, 185, 185);
      }
    }
  }
}
</style>